import { TFunction } from 'i18next';
import { AdressesLabel } from '../types/Adresses';

export const addressLabel = (t: TFunction): Record<AdressesLabel, string> => ({
  [AdressesLabel.HOME]: t('home'),
  [AdressesLabel.WORK]: t('work'),
  [AdressesLabel.OTHERS]: t('others'),
});
